<template>
    <v-container fluid class="pa-0">
    <v-card>
        <v-card-title>
            {{$t('event.restaurant')}}
            <v-spacer></v-spacer>
            <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{$t('Cancel')}}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{$t('Save')}}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{$t('Reorder')}}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn color="primary" @click="initAddRestaurant">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :loading="isRestaurantsPending"
                @pagination="currentPagination"
                :items="tableRestaurants"
                >
                <template v-slot:item.title="{value}">
                    {{value}}
                </template>
                <template v-slot:item.scroller="{value}">
                    <div v-show="isEditOrderMode" class="handle"><v-btn icon ><v-icon>drag_handle{{value}}</v-icon></v-btn></div>
                    <div v-show="!isEditOrderMode"></div>
                </template>
                <template v-slot:item.items="{item,value}">
                    {{getLength(item)}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="primary" class="ma-2" :disabled="isEditOrderMode"
                        @click="initEditRestaurant(item)">
                        {{$t('edit')}}
                        <v-icon right>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn color="red" :dark="!isEditOrderMode" class="ma-2" :disabled="isEditOrderMode"
                        @click="deleteRestaurant(item)">
                        {{$t('delete')}}
                        <v-icon right>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>

        <v-dialog v-model="showEditRestaurantDialog"
            persistent
            fullscreen
            hide-overlay
            >
            <v-card id="vCard">
                <v-app-bar fixed dark color="primary">
                    <v-btn icon dark @click="closeEditRestaurant">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <span class="app-bar">{{$t('event.restaurant')}}</span>
                </v-app-bar>
                <v-container class="pt-16">
                    <v-row>
                        <v-col class="py-0 mt-5">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.name')"
                                        :placeholder="$t('event_restaurant.name')"
                                        v-model="editingRestaurantItem.name"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.name_tc')"
                                        :placeholder="$t('event_restaurant.name_tc')"
                                        v-model="editingRestaurantItem.name_tc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.name_sc')"
                                        :placeholder="$t('event_restaurant.name_sc')"
                                        v-model="editingRestaurantItem.name_sc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.address')"
                                        :placeholder="$t('event_restaurant.address')"
                                        v-model="editingRestaurantItem.address"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.address_tc')"
                                        :placeholder="$t('event_restaurant.address_tc')"
                                        v-model="editingRestaurantItem.address_tc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.address_sc')"
                                        :placeholder="$t('event_restaurant.address_sc')"
                                        v-model="editingRestaurantItem.address_sc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.address_description')"
                                        :placeholder="$t('event_restaurant.address_description')"
                                        v-model="editingRestaurantItem.address_description"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.address_description_tc')"
                                        :placeholder="$t('event_restaurant.address_description_tc')"
                                        v-model="editingRestaurantItem.address_description_tc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.address_description_sc')"
                                        :placeholder="$t('event_restaurant.address_description_sc')"
                                        v-model="editingRestaurantItem.address_description_sc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.opening_hours')"
                                        :placeholder="$t('event_restaurant.opening_hours')"
                                        v-model="editingRestaurantItem.opening_hours"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.contact')"
                                        :placeholder="$t('event_restaurant.contact')"
                                        v-model="editingRestaurantItem.contact"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.capacity')"
                                        :placeholder="$t('event_restaurant.capacity')"
                                        v-model="editingRestaurantItem.capacity"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.key')"
                                        :placeholder="$t('event_restaurant.key')"
                                        v-model="editingRestaurantItem.key"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.lunchKey')"
                                        :placeholder="$t('event_restaurant.lunchKey')"
                                        v-model="editingRestaurantItem.preference_key"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-file-input accept="image/*"
                                    :label="$t('event_restaurant.banner')"
                                    v-model="editingRestaurantItem.banner">
                            <template v-slot:selection="{file}">
                                <v-img :src="getFileUrl(file)"
                                        max-width="250px"
                                        max-height="250px"></v-img>
                            </template>
                        </v-file-input>
                    </v-row>
                    <v-row>
                        <v-file-input accept="image/*"
                                    :label="$t('event_restaurant.map')"
                                    v-model="editingRestaurantItem.map">
                            <template v-slot:selection="{file}">
                                <v-img :src="getFileUrl(file)"
                                        max-width="250px"
                                        max-height="250px"></v-img>
                            </template>
                        </v-file-input>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.mapId')"
                                        :placeholder="$t('event_restaurant.mapId')"
                                        v-model="editingRestaurantItem.mapId"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.mapId_tc')"
                                        :placeholder="$t('event_restaurant.mapId_tc')"
                                        v-model="editingRestaurantItem.mapId_tc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.mapId_sc')"
                                        :placeholder="$t('event_restaurant.mapId_sc')"
                                        v-model="editingRestaurantItem.mapId_sc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.google_map_link')"
                                        :placeholder="$t('event_restaurant.google_map_link')"
                                        v-model="editingRestaurantItem.google_map_link"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.google_map_link_tc')"
                                        :placeholder="$t('event_restaurant.google_map_link_tc')"
                                        v-model="editingRestaurantItem.google_map_link_tc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_restaurant.google_map_link_sc')"
                                        :placeholder="$t('event_restaurant.google_map_link_sc')"
                                        v-model="editingRestaurantItem.google_map_link_sc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-checkbox
                                :label="$t('event_restaurant.is_reserved')"
                                v-model="editingRestaurantItem.is_reserved"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-checkbox
                                :label="$t('event_restaurant.meal_box')"
                                v-model="editingRestaurantItem.meal_box"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row class="justify-end">
                        <v-label v-if="!selectedRestaurantId">
                            {{'Click save to start adding Restaurant items'}}
                        </v-label>
                        <div class="saveAgendaEditButton"></div>
                        <v-btn color="primary" @click="saveRestaurantEdit">
                            {{$t('save')}}
                        </v-btn>
                        <div class="saveAgendaEditButton"></div>
                    </v-row>
                    <v-row v-if="editingRestaurantItem && selectedRestaurantId">
                        <v-col>
                            <EventRestaurantItemList :restaurant-id="editingRestaurantItem.id"></EventRestaurantItemList>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>
    </v-container>
</template>
<style scoped>
    .saveAgendaEditButton{
        width:12px;
        height: 50px;
    }
    .button-spacer {
        width:10px;
    }

    .app-bar {
        font-size: 1.25rem; 
        line-height: 1.5; 
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;
        margin-left: 20px;
    }

</style>
<script>
    import {computed, ref, watch, onMounted} from '@vue/composition-api'
    import {useGet, useFind} from "feathers-vuex";
    import EventRestaurantItemList from "./EventRestaurantItemList";
    import { cloneDeep,differenceWith, difference } from 'lodash';
    import Sortable from "sortablejs";

    export default {
        name: 'EventRestaurant',
        components: {EventRestaurantItemList},
        setup(props, {root}) {
            const {Event,EventRestaurant} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);

            const {item: event, isPending} = useGet({model: Event, id: eventId.value});
            
            const restaurantParams = computed(()=>{
                return {
                    query:{
                        eventId: eventId.value
                    },
                    $sort:{
                        order: 1
                    }
                }
            })
            const {items: restaurants, isPending: isRestaurantsPending} = useFind({
                model: EventRestaurant,
                params: restaurantParams,
            })
            
            const isEditOrderMode = ref(false);
            const didOrderChange = ref(false);
            const editOrderRestaurants = ref([]);
            const selectedRestaurantId=ref(null);

            const overlay = ref(false);

            const closeEditRestaurant = function() {
                showEditRestaurantDialog.value = false;
                selectedRestaurantId.value = null
            }
            const headers = ref([
                {text: '',value:'scroller',width:80},
                {text: 'Order',value:'order'},
                {text: 'Name',value:'name'},
                {text: 'Address',value:'address'},
                {text: 'Restaurant Items',value:'items'},
                {text: '',value:'actions'},
            ])

            const previewHtmlContentOption = {
                 modules: {
                    toolbar: false,
                },
                placeholder: '',
                theme: 'bubble',
            };

            const editingRestaurantItem = ref(new EventRestaurant({eventId: eventId.value}))
            const showEditRestaurantDialog = ref(false);

            const initEditRestaurant = function(restaurant){
                editingRestaurantItem.value = restaurant
                showEditRestaurantDialog.value = true
                selectedRestaurantId.value = restaurant.id
            }
            const initAddRestaurant = function(){
                showEditRestaurantDialog.value = true
                editingRestaurantItem.value = new EventRestaurant({eventId: eventId.value})
                selectedRestaurantId.value = null
                console.log(restaurants.value);
                editingRestaurantItem.value.order = restaurants.value.length + 1;
            }

            const deleteRestaurant = function(item){
                if(confirm(root.$t('event_restaurant.confirm_delete'))){
                    item.remove().then(()=>{
                        root.$store.dispatch('showSnackBar', root.$t('event_restaurant.delete_successful'));
                    }, root.$handleFeatherError.bind(root));
                }
            }
            const getLength = function(item){
                return item?(item.items?item.items.length:0):0
            }

            const saveRestaurantEdit = async function(){
                if( editingRestaurantItem.value.banner instanceof File){
                    editingRestaurantItem.value.banner = {src:await root.$uploadFile(editingRestaurantItem.value.banner)};
                }
                if (!editingRestaurantItem.value.banner) {
                    editingRestaurantItem.value.banner = null;
                }
                if( editingRestaurantItem.value.map instanceof File){
                    editingRestaurantItem.value.map = {src:await root.$uploadFile(editingRestaurantItem.value.map)};
                }
                if (!editingRestaurantItem.value.map) {
                    editingRestaurantItem.value.map = null;
                }
                editingRestaurantItem.value.save().then(async (savedAgenda)=>{
                    editingRestaurantItem.value = savedAgenda
                    selectedRestaurantId.value = savedAgenda.id
                    root.$store.dispatch('showSnackBar', root.$t('event_restaurant.save_successful'));
                })

            }
            const initEditOrder = function(){
                didOrderChange.value = false
                isEditOrderMode.value = true
                editOrderRestaurants.value = cloneDeep(sortedRestaurants.value)
            }

            const saveEditOrder =  async function(){
                if(!didOrderChange.value){
                    isEditOrderMode.value = false
                    return;
                }

                overlay.value = true
                for(let i=0;i<editOrderRestaurants.value.length;i++){
                    await editOrderRestaurants.value[i].save().then(()=>{
                        EventRestaurant.get(editOrderRestaurants.value[i].id)
                    })
                }
                isEditOrderMode.value = false
                overlay.value = false;
            }

            const cancelEditOrder = function(){
                isEditOrderMode.value = false
            }
            const quickSortRestaurants = function(sortRestaurants){
                if(sortRestaurants.length<2){
                    return sortRestaurants
                }

                const chosenIndex = sortRestaurants.length - 1
                const chosen  = sortRestaurants[chosenIndex]
                const a = []
                const b = []
                for(let i=0;i<chosenIndex;i++){
                    const temp = sortRestaurants[i].order
                    temp < chosen.order ? a.push(sortRestaurants[i]) : b.push(sortRestaurants[i])
                }
                const output = [...quickSortRestaurants(a),chosen,...quickSortRestaurants(b)]
                return output
            }

            const sortedRestaurants = computed(()=>{
                return quickSortRestaurants(restaurants.value)
            })
            const currentStart = ref(0);// Holds the index of starting item in speakerItemList in the current page of v-table
            const currentPagination = function(e){ // Update current page
                currentStart.value=e.pageStart
            }
            onMounted(() => {
                let table = document.querySelector('.v-data-table tbody');
                Sortable.create(table,
                    {
                        handle:".handle", // Look for class with name "handle"
                        onEnd({newIndex,oldIndex}){
                            didOrderChange.value = true;
                            newIndex +=  currentStart.value;
                            oldIndex +=  currentStart.value;
                            const rowSelected = editOrderRestaurants.value.splice(oldIndex,1)[0];
                            editOrderRestaurants.value.splice(newIndex,0,rowSelected);

                            for(let i=0;i<editOrderRestaurants.value.length;i++){
                                editOrderRestaurants.value[i].order = i+1
                            }
                            editOrderRestaurants.value = quickSortRestaurants(editOrderRestaurants.value);
                        }
                    }
                )
            });

            watch(showEditRestaurantDialog, (newVal, oldVal) => {
                if (newVal) {
                    document.getElementById('vCard').scrollIntoView();
                }
            })

            const tableRestaurants = computed(()=>{
                return isEditOrderMode.value ? editOrderRestaurants.value : sortedRestaurants.value
            })

            return {
                headers,
                tableRestaurants,
                isRestaurantsPending,
                previewHtmlContentOption,
                isEditOrderMode,
                currentPagination,

                editingRestaurantItem,
                showEditRestaurantDialog,
                closeEditRestaurant,
                initEditRestaurant,
                initAddRestaurant,
                selectedRestaurantId,

                deleteRestaurant,
                getLength,
                saveRestaurantEdit,

                initEditOrder,
                saveEditOrder,
                cancelEditOrder,

                overlay,
                getFileUrl: root.$getFileURL,
            }
        },
    }
</script>